import { Url } from '../../utils/codecUtils';

export const getBlob = (documentUrl: Url) => {
  return {
    endpoint: documentUrl,
    method: 'GET',
    responseType: 'blob',
  } as const;
};
